import React from 'react'

import'./trainingsession.css'

function Trainingsession(){
    return (
        <div>
            <div className="container-fluid training-session-container-main text-center p-5">
                <div className="container training-session-container">
                    <h1 id="training-session-heading">Training Session</h1>
                    <div className="training-session-wrapper">
                        <div className="p-4 training-session-info">
                            <h2>Wednesday</h2>
                                <div className="training-session-innerdiv">
                                <h6>Time: 5pm</h6>
                                <h5>@ Rainbow Bakery & Cafe</h5>
                                <small>OR</small>
                                <h5>6pm | randall's island</h5>
                            </div>
                        </div>
                        <div className="p-4 training-session-info">
                                <h2>Saturday</h2>
                            <div className="training-session-innerdiv">
                                <h6>Time: 10am</h6>
                                <h5>@ Rainbow Bakery & Cafe</h5>
                                <small>OR</small>
                                <h5>11am | randall's island</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Trainingsession